import React, { useState } from 'react';
import { Input, Button } from '@blueprintnyc/bpnyc-common-admin';
import ImageUpload from 'components/ImageUpload';
import NumericalCheck from 'components/NumericalCheck';
import config from 'config';
import { captureEvent } from 'utils';
import './EventCreate.scss';

const EventCreate = props => {
	const { onFinish, currentClientID, submitting } = props;
	const [values, setValues] = useState({});

	const signedUrlEndpoint = `${config.baseUrl}/${currentClientID}/upload/media/signed_url`;

	const handleSubmit = () => {
		if (onFinish) {
			onFinish(values);
			captureEvent('event_create_submitted', {
				client_id: currentClientID,
				event_name: values.name,
				event_image_url: values.image_url,
				event_location: values.location,
			});
		}
	};

	const updateValue = (field, value) => {
		setValues(prevValues => ({ ...prevValues, [field]: value }));
	};

	const handleValueChange = field => {
		return value => updateValue(field, value);
	};

	const isEnabled = values.name && values.location && !submitting;

	return (
		<div className="EventCreate">
			<div className="row">
				<div className="label">
					<NumericalCheck number={1} completed={!!values.name} />
					Give your event a name
				</div>
				<Input
					value={values.name}
					placeholder="My First Event"
					onChange={handleValueChange('name')}
				/>
			</div>
			<div className="row">
				<div className="label">
					<NumericalCheck number={2} completed={!!values.image_url} />
					Add an event image
				</div>
				<ImageUpload
					endpoint={signedUrlEndpoint}
					value={values.image_url}
					onChange={handleValueChange('image_url')}
				/>
			</div>
			<div className="row">
				<div className="label">
					<NumericalCheck number={3} completed={!!values.location} />
					Where's this event being held?
				</div>
				<Input
					value={values.location}
					placeholder="Planet Earth"
					onChange={handleValueChange('location')}
				/>
			</div>
			<div className="buttons">
				<Button disabled={!isEnabled} onClick={handleSubmit}>
					{submitting ? 'Creating…' : 'Continue'}
				</Button>
			</div>
		</div>
	);
};

export default EventCreate;
